import React, { useState, useEffect } from "react";
import "./Header.css";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Menu, Drawer } from "antd";
import Logo from "../../../assets/weblogo.png";
import About from "../../../assets/About.png";
import team from "../../../assets/team.svg";
import physiotherapist from "../../../assets/physiotherapist.png";
import protection from "../../../assets/protection.png";
import stethoscope from "../../../assets/stethoscope.svg";
import screwdriver from "../../../assets/screwdriver.svg";
import informationtechnology from "../../../assets/informationtechnology.png";
import skills from "../../../assets/skills.png";
import accounting from "../../../assets/accounting.png";
import technician from "../../../assets/technician.png";
import cooking from "../../../assets/cooking.png";
import student from "../../../assets/student.jpg";
import step2 from "../../../assets/step2.png";
import employer from "../../../assets/employer.svg";
import step1 from "../../../assets/step1.png";
import visitor from "../../../assets/visitor.svg";
import labour from "../../../assets/labour.webp";
import dama from "../../../assets/dama.svg";
import therap from "../../../assets/therap.png";
import healthInsua from "../../../assets/healthInsua.png";
import PY from "../../../assets/PY.png";
import resources from "../../../assets/resources.png";
import socialIcon from "../../../assets/socialIcon.png";
import PTEicon from "../../../assets/PTEicon.png";
import IELTSicon from "../../../assets/IELTSicon.svg";
import NAATIicon from "../../../assets/NAATIicon.png";
import ArtVisaAppeals from "../../../assets/ArtVisaAppeals.svg";
import blogIcon from "../../../assets/blogIcon.png";
import referFriend from "../../../assets/referFriend.png";
import IntroIcon from "../../../assets/IntroIcon.png";
import sponserVisa from "../../../assets/sponserVisa.png";
import ENS from "../../../assets/ENS.png";


const { SubMenu } = Menu;
const Navigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [visible, setVisible] = useState(false);
  const showDrawer = () => setVisible(true);
  const closeDrawer = () => setVisible(false);
  const [activeLink, setActiveLink] = useState(location.pathname);
  useEffect(() => {
    setActiveLink(location.pathname);
  }, [location.pathname]);
  return (
    <>
      <div
        data-animation="default"
        data-collapse="medium"
        data-duration="400"
        data-easing="ease"
        data-easing2="ease"
        role="banner"
        className="nav-component w-nav custom-component"
      >
        <div className="nav-container">
          <div
            id="w-node-d32c70ed-cd18-f07b-d663-cb15cd7e6a6d-cd7e6a6b"
            className="first-element"
          >
            <Link to="/" aria-current="page" className="brand w-nav-brand">
              <img src={Logo} loading="lazy" width="200" alt="Logo" />
            </Link>
          </div>

          <div id="w-node-d32c70ed-cd18-f07b-d663-cb15cd7e6a73-cd7e6a6b">
            <div className="shrink-item">
              <div className="flex-center">
                <nav role="navigation" className="nav-menu w-nav-menu">
                  <div className="dropdown w-dropdown">
                    <div className="dropdown-toggle w-dropdown-toggle">
                      <div>About</div>
                      <img
                        src="https://cdn.prod.website-files.com/65790d6f586010464b337aff/65790d6f586010464b337c23_arrow_right_FILL0_wght400_GRAD0_opsz24.svg"
                        loading="lazy"
                        width="10"
                        alt=""
                        className="dropdown-arrow"
                      />
                    </div>
                    <nav className="dropdown-main-list w-dropdown-list">
                      <div className="dropdown-wrapper-list p-2">
                        <div className="collection-list-wrapper w-dyn-list">
                          <div
                            role="list"
                            className="collection-list w-dyn-items"
                          >
                            <div role="listitem" className="w-dyn-item">
                              <Link
                                to="/About"
                                className="dropdown-link-big w-inline-block"
                              >
                                <div className="item-heading">
                                  <img
                                    src={About}
                                    alt="Logo"
                                    className="logo-small"
                                  />
                                  Our Story
                                </div>
                              </Link>
                            </div>

                            <div role="listitem" className="w-dyn-item">
                              <Link
                                to="/MeetTeam"
                                className="dropdown-link-big w-inline-block"
                              >
                                <div className="item-heading">
                                  <img
                                    src={
                                      team
                                    } /* Replace with the actual logo source */
                                    alt="Leadership Logo"
                                    className="logo-small"
                                  />
                                  Leadership Team
                                </div>
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </nav>
                  </div>

                  <div className="dropdown w-dropdown">
                    <div className="dropdown-toggle w-dropdown-toggle">
                      <div>Student Services</div>
                      <img
                        src="https://cdn.prod.website-files.com/65790d6f586010464b337aff/65790d6f586010464b337c23_arrow_right_FILL0_wght400_GRAD0_opsz24.svg"
                        loading="lazy"
                        width="10"
                        alt=""
                        className="dropdown-arrow"
                      />
                    </div>
                    <nav className="dropdown-main-list w-dropdown-list">
                      <div className="dropdown-wrapper-list p-2">
                        <div className="collection-list-wrapper w-dyn-list">
                          <div
                            role="list"
                            className="collection-list w-dyn-items"
                          >
                            <div className="item-heading">
                              <h5>Courses</h5>
                            </div>
                            <div role="listitem" className="w-dyn-item">
                              <Link
                                to="/EarlyChild"
                                className="dropdown-link-big w-inline-block"
                              >
                                <div className="item-heading">
                                  <img
                                    src={physiotherapist}
                                    alt="Early Childhood Logo"
                                    className="logo-small"
                                  />
                                  Early Childhood Education & Care
                                </div>
                              </Link>
                            </div>

                            <div role="listitem" className="w-dyn-item">
                              <Link
                                to="/Nursing"
                                className="dropdown-link-big w-inline-block"
                              >
                                <div className="item-heading">
                                  <img
                                    src={
                                      stethoscope
                                    } /* Replace with the actual logo source */
                                    alt="Nursing Logo"
                                    className="logo-small"
                                  />
                                  Nursing
                                </div>
                              </Link>
                            </div>

                            <div role="listitem" className="w-dyn-item">
                              <Link
                                to="/SocialWork"
                                className="dropdown-link-big w-inline-block"
                              >
                                <div className="item-heading">
                                  <img
                                    src={
                                      socialIcon
                                    } /* Replace with the actual logo source */
                                    alt="SocialWork Logo"
                                    className="logo-small"
                                  />
                                  Social Work
                                </div>
                              </Link>
                            </div>

                            <div role="listitem" className="w-dyn-item">
                              <Link
                                to="/BuildConstru"
                                className="dropdown-link-big w-inline-block"
                              >
                                <div className="item-heading">
                                  <img
                                    src={
                                      screwdriver
                                    } /* Replace with the actual logo source */
                                    alt="Building & Construction Logo"
                                    className="logo-small"
                                  />
                                  Building & Construction
                                </div>
                              </Link>
                            </div>

                            <div role="listitem" className="w-dyn-item">
                              <Link
                                to="/InfoTech"
                                className="dropdown-link-big w-inline-block"
                              >
                                <div className="item-heading">
                                  <img
                                    src={
                                      informationtechnology
                                    } /* Replace with the actual logo source */
                                    alt="Information Technology Logo"
                                    className="logo-small"
                                  />
                                  Information Technology
                                </div>
                              </Link>
                            </div>

                            <div role="listitem" className="w-dyn-item">
                              <Link
                                to="/Engineer"
                                className="dropdown-link-big w-inline-block"
                              >
                                <div className="item-heading">
                                  <img
                                    src={
                                      skills
                                    } /* Replace with the actual logo source */
                                    alt="Engineering Logo"
                                    className="logo-small"
                                  />
                                  Engineering
                                </div>
                              </Link>
                            </div>

                            <div role="listitem" className="w-dyn-item">
                              <Link
                                to="/Accounting"
                                className="dropdown-link-big w-inline-block"
                              >
                                <div className="item-heading">
                                  <img
                                    src={
                                      accounting
                                    } /* Replace with the actual logo source */
                                    alt="Accounting Logo"
                                    className="logo-small"
                                  />
                                  Accounting
                                </div>
                              </Link>
                            </div>

                            <div role="listitem" className="w-dyn-item">
                              <Link
                                to="/OccupationalTherapy"
                                className="dropdown-link-big w-inline-block"
                              >
                                <div className="item-heading">
                                  <img
                                    src={
                                      therap
                                    } /* Replace with the actual logo source */
                                    alt="Occupational Therapy Logo"
                                    className="logo-small"
                                  />
                                  Occupational Therapy
                                </div>
                              </Link>
                            </div>

                            <div role="listitem" className="w-dyn-item">
                              <Link
                                to="/AutoTech"
                                className="dropdown-link-big w-inline-block"
                              >
                                <div className="item-heading">
                                  <img
                                    src={
                                      technician
                                    } /* Replace with the actual logo source */
                                    alt="Automotive Technician Logo"
                                    className="logo-small"
                                  />
                                  Automotive Technician
                                </div>
                              </Link>
                            </div>

                            <div role="listitem" className="w-dyn-item">
                              <Link
                                to="/Cookery"
                                className="dropdown-link-big w-inline-block"
                              >
                                <div className="item-heading">
                                  <img
                                    src={
                                      cooking
                                    } /* Replace with the actual logo source */
                                    alt="Cookery Logo"
                                    className="logo-small"
                                  />
                                  Cookery
                                </div>
                              </Link>
                            </div>
                          </div>
                          <div
                            role="list"
                            className="collection-list w-dyn-items"
                          >
                            <div className="item-heading">
                              <h5>Services</h5>
                            </div>

                            <div role="listitem" className="w-dyn-item">
                              <Link
                                to="/HealthInsuarance"
                                className="dropdown-link-big w-inline-block"
                              >
                                <div className="item-heading">
                                  <img
                                    src={
                                      healthInsua
                                    } /* Replace with the actual logo source */
                                    alt="Health Insurance Logo"
                                    className="logo-small"
                                  />
                                  Health Insurance
                                </div>
                              </Link>
                            </div>

                            <div role="listitem" className="w-dyn-item">
                              <Link
                                to="/ProfessionalYear"
                                className="dropdown-link-big w-inline-block"
                              >
                                <div className="item-heading">
                                  <img
                                    src={
                                      PY
                                    } /* Replace with the actual logo source */
                                    alt="Professional Year Logo"
                                    className="logo-small"
                                  />
                                  Professional Year
                                </div>
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </nav>
                  </div>

                  <div className="dropdown w-dropdown">
                    <div className="dropdown-toggle w-dropdown-toggle">
                      <div>Migration Services</div>
                      <img
                        src="https://cdn.prod.website-files.com/65790d6f586010464b337aff/65790d6f586010464b337c23_arrow_right_FILL0_wght400_GRAD0_opsz24.svg"
                        loading="lazy"
                        width="10"
                        alt=""
                        className="dropdown-arrow"
                      />
                    </div>
                    <nav className="dropdown-main-list w-dropdown-list">
                      <div className="dropdown-wrapper-list p-2">
                        <div className="collection-list-wrapper w-dyn-list">
                          <div
                            role="list"
                            className="collection-list w-dyn-items"
                          >
                            <div role="listitem" className="w-dyn-item">
                              <Link
                                to="/StudentVisas"
                                className="dropdown-link-big w-inline-block"
                              >
                                <div className="item-heading">
                                  <img
                                    src={
                                      student
                                    } /* Replace with the actual logo source */
                                    alt="Student Visas Logo"
                                    className="logo-small"
                                  />
                                  Student Visas
                                </div>
                              </Link>
                            </div>

                            <div role="listitem" className="w-dyn-item">
                              <Link
                                to="/SkilledVisas"
                                className="dropdown-link-big w-inline-block"
                              >
                                <div className="item-heading">
                                  <img
                                    src={
                                      step2
                                    } /* Replace with the actual logo source */
                                    alt="Skilled Visas Logo"
                                    className="logo-small"
                                  />
                                  Skilled Visas
                                </div>
                              </Link>
                            </div>

                            <div role="listitem" className="w-dyn-item">
                              <Link
                                to="/EmployerVisas"
                                className="dropdown-link-big w-inline-block"
                              >
                                <div className="item-heading">
                                  <img
                                    src={
                                      employer
                                    } /* Replace with the actual logo source */
                                    alt="Employer-Sponsored Visas Logo"
                                    className="logo-small"
                                  />
                                  Employer-Sponsored Visas
                                </div>
                              </Link>
                            </div>

                            <div role="listitem" className="w-dyn-item">
                              <Link
                                to="/FamilyVisas"
                                className="dropdown-link-big w-inline-block"
                              >
                                <div className="item-heading">
                                  <img
                                    src={
                                      step1
                                    } /* Replace with the actual logo source */
                                    alt="Family And Partner Visas Logo"
                                    className="logo-small"
                                  />
                                  Family And Partner Visas
                                </div>
                              </Link>
                            </div>

                            <div role="listitem" className="w-dyn-item">
                              <Link
                                to="/VisitorVisas"
                                className="dropdown-link-big w-inline-block"
                              >
                                <div className="item-heading">
                                  <img
                                    src={
                                      visitor
                                    } /* Replace with the actual logo source */
                                    alt="Visitor Visas Logo"
                                    className="logo-small"
                                  />
                                  Visitor Visas
                                </div>
                              </Link>
                            </div>

                            <div role="listitem" className="w-dyn-item">
                              <Link
                                to="/LabourAgreements"
                                className="dropdown-link-big w-inline-block"
                              >
                                <div className="item-heading">
                                  <img
                                    src={
                                      labour
                                    } /* Replace with the actual logo source */
                                    alt="Labour Agreements Logo"
                                    className="logo-small"
                                  />
                                  Labour Agreements
                                </div>
                              </Link>
                            </div>

                            <div role="listitem" className="w-dyn-item">
                              <Link
                                to="/SkillsAssessment"
                                className="dropdown-link-big w-inline-block"
                              >
                                <div className="item-heading">
                                  <img
                                    src={
                                      skills
                                    } /* Replace with the actual logo source */
                                    alt="Skills Assessment Logo"
                                    className="logo-small"
                                  />
                                  Skills Assessment
                                </div>
                              </Link>
                            </div>

                            <div role="listitem" className="w-dyn-item">
                              <Link
                                to="/DAMA"
                                className="dropdown-link-big w-inline-block"
                              >
                                <div className="item-heading">
                                  <img
                                    src={
                                      dama
                                    } /* Replace with the actual logo source */
                                    alt="DAMA Logo"
                                    className="logo-small"
                                  />
                                  DAMA
                                </div>
                              </Link>
                            </div>

                            <div role="listitem" className="w-dyn-item">
                              <Link
                                to="/ArtVisaAppeals"
                                className="dropdown-link-big w-inline-block"
                              >
                                <div className="item-heading">
                                  <img
                                    src={
                                      ArtVisaAppeals
                                    } /* Replace with the actual logo source */
                                    alt="DAMA Logo"
                                    className="logo-small"
                                  />
                                  ART Visa Appeals
                                </div>
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </nav>
                  </div>

                  <div className="dropdown w-dropdown">
                    <div className="dropdown-toggle w-dropdown-toggle">
                      <div>Corporate Services</div>
                      <img
                        src="https://cdn.prod.website-files.com/65790d6f586010464b337aff/65790d6f586010464b337c23_arrow_right_FILL0_wght400_GRAD0_opsz24.svg"
                        loading="lazy"
                        width="10"
                        alt=""
                        className="dropdown-arrow"
                      />
                    </div>
                    <nav className="dropdown-main-list w-dropdown-list">
                      <div className="dropdown-wrapper-list p-2">
                        <div className="collection-list-wrapper w-dyn-list">
                          <div
                            role="list"
                            className="collection-list w-dyn-items"
                          >
                            <div role="listitem" className="w-dyn-item">
                              <Link
                                to="/Introduction"
                                className="dropdown-link-big w-inline-block"
                              >
                                <div className="item-heading">
                                  <img
                                    src={
                                      IntroIcon
                                    } /* Replace with the actual logo source */
                                    alt="Student Visas Logo"
                                    className="logo-small"
                                  />
                                  Introduction
                                </div>
                              </Link>
                            </div>

                            <div role="listitem" className="w-dyn-item">
                              <Link
                                to="/SponsorVisaApp"
                                className="dropdown-link-big w-inline-block"
                              >
                                <div className="item-heading">
                                  <img
                                    src={
                                      sponserVisa
                                    } /* Replace with the actual logo source */
                                    alt="Skilled Visas Logo"
                                    className="logo-small"
                                  />
                                  Sponsor Visa Application Services
                                </div>
                              </Link>
                            </div>

                            <div role="listitem" className="w-dyn-item">
                              <Link
                                to="/SkillInDemand"
                                className="dropdown-link-big w-inline-block"
                              >
                                <div className="item-heading">
                                  <img
                                    src={
                                      step2
                                    } /* Replace with the actual logo source */
                                    alt="Employer-Sponsored Visas Logo"
                                    className="logo-small"
                                  />
                                  Skills in Demand Visa
                                </div>
                              </Link>
                            </div>

                            <div role="listitem" className="w-dyn-item">
                              <Link
                                to="/EmployerNomVisa"
                                className="dropdown-link-big w-inline-block"
                              >
                                <div className="item-heading">
                                  <img
                                    src={
                                      ENS
                                    } /* Replace with the actual logo source */
                                    alt="Skills Assessment Logo"
                                    className="logo-small"
                                  />
                                  Employer Nomination Scheme Visa
                                </div>
                              </Link>
                            </div>

                            <div role="listitem" className="w-dyn-item">
                              <Link
                                to="/SkilledEmpSponRegionVisa "
                                className="dropdown-link-big w-inline-block"
                              >
                                <div className="item-heading">
                                  <img
                                    src={
                                      skills
                                    } /* Replace with the actual logo source */
                                    alt="Family And Partner Visas Logo"
                                    className="logo-small"
                                  />
                                  Skilled Employer Sponsored Regional Visa
                                </div>
                              </Link>
                            </div>

                            <div role="listitem" className="w-dyn-item">
                              <Link
                                to="/SponsorOblig"
                                className="dropdown-link-big w-inline-block"
                              >
                                <div className="item-heading">
                                  <img
                                    src={
                                      socialIcon
                                    } /* Replace with the actual logo source */
                                    alt="Visitor Visas Logo"
                                    className="logo-small"
                                  />
                                  Sponsorship Obligations
                                </div>
                              </Link>
                            </div>

                            <div role="listitem" className="w-dyn-item">
                              <Link
                                to="/AppealingSponsoeVisa"
                                className="dropdown-link-big w-inline-block"
                              >
                                <div className="item-heading">
                                  <img
                                    src={
                                      ArtVisaAppeals
                                    } /* Replace with the actual logo source */
                                    alt="Labour Agreements Logo"
                                    className="logo-small"
                                  />
                                  Appealing an Employer - Sponsored Visa
                                </div>
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </nav>
                  </div>

                  <div className="dropdown w-dropdown">
                    <div className="dropdown-toggle w-dropdown-toggle">
                      <div>Coaching</div>
                      <img
                        src="https://cdn.prod.website-files.com/65790d6f586010464b337aff/65790d6f586010464b337c23_arrow_right_FILL0_wght400_GRAD0_opsz24.svg"
                        loading="lazy"
                        width="10"
                        alt=""
                        className="dropdown-arrow"
                      />
                    </div>
                    <nav className="dropdown-main-list w-dropdown-list">
                      <div className="dropdown-wrapper-list p-2">
                        <div className="collection-list-wrapper w-dyn-list">
                          <div
                            role="list"
                            className="collection-list w-dyn-items"
                          >
                            <div role="listitem" className="w-dyn-item">
                              <Link
                                to="/PTE"
                                className="dropdown-link-big w-inline-block"
                              >
                                <div className="item-heading">
                                  <img
                                    src={
                                      PTEicon
                                    } /* Replace with the actual logo source */
                                    alt="Student Visas Logo"
                                    className="logo-small"
                                  />
                                  PTE
                                </div>
                              </Link>
                            </div>

                            <div role="listitem" className="w-dyn-item">
                              <Link
                                to="/IELTS"
                                className="dropdown-link-big w-inline-block"
                              >
                                <div className="item-heading">
                                  <img
                                    src={
                                      IELTSicon
                                    } /* Replace with the actual logo source */
                                    alt="Skilled Visas Logo"
                                    className="logo-small"
                                  />
                                  IELTS
                                </div>
                              </Link>
                            </div>

                            <div role="listitem" className="w-dyn-item">
                              <Link
                                to="/NAATI"
                                className="dropdown-link-big w-inline-block"
                              >
                                <div className="item-heading">
                                  <img
                                    src={
                                      NAATIicon
                                    } /* Replace with the actual logo source */
                                    alt="Employer-Sponsored Visas Logo"
                                    className="logo-small"
                                  />
                                  NAATI CCL
                                </div>
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </nav>
                  </div>

                  <div className="dropdown w-dropdown">
                    <div className="dropdown-toggle w-dropdown-toggle">
                      <div>Resources</div>
                      <img
                        src="https://cdn.prod.website-files.com/65790d6f586010464b337aff/65790d6f586010464b337c23_arrow_right_FILL0_wght400_GRAD0_opsz24.svg"
                        loading="lazy"
                        width="10"
                        alt=""
                        className="dropdown-arrow"
                      />
                    </div>
                    <nav className="dropdown-main-list w-dropdown-list">
                      <div className="dropdown-wrapper-list p-2">
                        <div className="collection-list-wrapper w-dyn-list">
                          <div
                            role="list"
                            className="collection-list w-dyn-items"
                          >
                            <div role="listitem" className="w-dyn-item">
                              <Link
                                to="/blog"
                                className="dropdown-link-big w-inline-block"
                              >
                                <div className="item-heading">
                                  <img
                                    src={
                                      blogIcon
                                    } /* Replace with the actual logo source */
                                    alt="Student Visas Logo"
                                    className="logo-small"
                                  />
                                  Blogs
                                </div>
                              </Link>
                            </div>

                            <div role="listitem" className="w-dyn-item">
                              <Link
                                to="/ReferFriend"
                                className="dropdown-link-big w-inline-block"
                              >
                                <div className="item-heading">
                                  <img
                                    src={
                                      referFriend
                                    } /* Replace with the actual logo source */
                                    alt="Skilled Visas Logo"
                                    className="logo-small"
                                  />
                                  Refer a Friend
                                </div>
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </nav>
                  </div>

                  <Link
                    to="/ContactUs"
                    className={`nav-link w-nav-link ${
                      activeLink === "/ContactUs" ? "w--current" : ""
                    }`}
                  >
                    {" "}
                    Contact
                  </Link>
                </nav>
              </div>
            </div>
          </div>

          <div className="flex-nav-button">
            <div className="email-flex">
              <a
                href="https://visa-winmigrationgroup.zohobookings.com.au/#/winmigrationgroup"
                target="_blank"
                className="button-underline w-inline-block"
              >
                <div className="button-color">Book a Consultation</div>
                <div className="line-animation">
                  <div className="underline"></div>
                </div>
              </a>
            </div>
            <div className="menu-button w-nav-button" onClick={showDrawer}>
              <img
                src="https://cdn.prod.website-files.com/64dde8491796b73c619e78bf/64dde8491796b73c619e7953_icon-menu.svg"
                loading="lazy"
                width="30"
                alt=""
                className="invert-hamburger"
              />
            </div>

            <Drawer
              title="Menu"
              placement="left"
              closable={false}
              onClose={closeDrawer}
              visible={visible}
              width={250}
            >
              <Menu
                mode="inline"
                selectedKeys={[activeLink]}
                style={{ height: "100%", borderRight: 0 }}
              >
                <Menu.Item key="/" onClick={closeDrawer}>
                  <Link to="/" className={activeLink === "/" ? "active" : ""}>
                    {" "}
                    Home
                  </Link>
                </Menu.Item>

                <SubMenu key="sub3" title="About">
                  <Menu.Item key="/About" onClick={closeDrawer}>
                    <Link
                      to="/About"
                      className={activeLink === "/About" ? "active" : ""}
                    >
                      {" "}
                      Our Story
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="/MeetTeam" onClick={closeDrawer}>
                    <Link
                      to="/MeetTeam"
                      className={activeLink === "/MeetTeam" ? "active" : ""}
                    >
                      {" "}
                      Meet The Team
                    </Link>
                  </Menu.Item>
                </SubMenu>

                <SubMenu key="sub2" title="Student Services">
                  <SubMenu key="sub4" title="Courses">
                    <Menu.Item key="/EarlyChild" onClick={closeDrawer}>
                      <Link
                        to="/EarlyChild"
                        className={activeLink === "/EarlyChild" ? "active" : ""}
                      >
                        {" "}
                        Early Childhood Education & Care
                      </Link>
                    </Menu.Item>
                    <Menu.Item key="/Nursing" onClick={closeDrawer}>
                      <Link
                        to="/Nursing"
                        className={activeLink === "/Nursing" ? "active" : ""}
                      >
                        {" "}
                        Nursing
                      </Link>
                    </Menu.Item>
                    <Menu.Item key="/SocialWork" onClick={closeDrawer}>
                      <Link
                        to="/SocialWork"
                        className={activeLink === "/SocialWork" ? "active" : ""}
                      >
                        {" "}
                        Social Work
                      </Link>
                    </Menu.Item>
                    <Menu.Item key="/BuildConstru" onClick={closeDrawer}>
                      <Link
                        to="/BuildConstru"
                        className={
                          activeLink === "/BuildConstru" ? "active" : ""
                        }
                      >
                        {" "}
                        Building & Construction
                      </Link>
                    </Menu.Item>
                    <Menu.Item key="/InfoTech" onClick={closeDrawer}>
                      <Link
                        to="/InfoTech"
                        className={activeLink === "/InfoTech" ? "active" : ""}
                      >
                        {" "}
                        Information Technology
                      </Link>
                    </Menu.Item>
                    <Menu.Item key="/Engineer" onClick={closeDrawer}>
                      <Link
                        to="/Engineer"
                        className={activeLink === "/Engineer" ? "active" : ""}
                      >
                        {" "}
                        Engineering
                      </Link>
                    </Menu.Item>
                    <Menu.Item key="/Accounting" onClick={closeDrawer}>
                      <Link
                        to="/Accounting"
                        className={activeLink === "/Accounting" ? "active" : ""}
                      >
                        {" "}
                        Accounting
                      </Link>
                    </Menu.Item>
                    <Menu.Item key="/OccupationalTherapy" onClick={closeDrawer}>
                      <Link
                        to="/OccupationalTherapy"
                        className={
                          activeLink === "/OccupationalTherapy" ? "active" : ""
                        }
                      >
                        {" "}
                        Occupational Therapy
                      </Link>
                    </Menu.Item>
                    <Menu.Item key="/AutoTech" onClick={closeDrawer}>
                      <Link
                        to="/AutoTech"
                        className={activeLink === "/AutoTech" ? "active" : ""}
                      >
                        {" "}
                        Automotive Technician
                      </Link>
                    </Menu.Item>
                    <Menu.Item key="/Cookery" onClick={closeDrawer}>
                      <Link
                        to="/Cookery"
                        className={activeLink === "/Cookery" ? "active" : ""}
                      >
                        {" "}
                        Cookery
                      </Link>
                    </Menu.Item>
                  </SubMenu>
                  <SubMenu key="sub5" title="Services">
                    <Menu.Item key="/HealthInsuarance" onClick={closeDrawer}>
                      <Link
                        to="/HealthInsuarance"
                        className={
                          activeLink === "/HealthInsuarance" ? "active" : ""
                        }
                      >
                        {" "}
                        Health Insuarance
                      </Link>
                    </Menu.Item>
                    <Menu.Item key="/ProfessionalYear" onClick={closeDrawer}>
                      <Link
                        to="/ProfessionalYear"
                        className={
                          activeLink === "/ProfessionalYear" ? "active" : ""
                        }
                      >
                        {" "}
                        Professional Year
                      </Link>
                    </Menu.Item>
                  </SubMenu>
                </SubMenu>

                <SubMenu key="sub1" title="Migration Services">
                  <Menu.Item key="/StudentVisas" onClick={closeDrawer}>
                    <Link
                      to="/StudentVisas"
                      className={activeLink === "/StudentVisas" ? "active" : ""}
                    >
                      {" "}
                      Student Visas
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="/SkilledVisas" onClick={closeDrawer}>
                    <Link
                      to="/SkilledVisas"
                      className={activeLink === "/SkilledVisas" ? "active" : ""}
                    >
                      {" "}
                      Skilled Visas
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="/EmployerVisas" onClick={closeDrawer}>
                    <Link
                      to="/EmployerVisas"
                      className={
                        activeLink === "/EmployerVisas" ? "active" : ""
                      }
                    >
                      {" "}
                      Employer-Sponsored Visas
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="/FamilyVisas" onClick={closeDrawer}>
                    <Link
                      to="/FamilyVisas"
                      className={activeLink === "/FamilyVisas" ? "active" : ""}
                    >
                      {" "}
                      Family And Partner Visas
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="/VisitorVisas" onClick={closeDrawer}>
                    <Link
                      to="/VisitorVisas"
                      className={activeLink === "/VisitorVisas" ? "active" : ""}
                    >
                      {" "}
                      Visitor Visas
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="/LabourAgreements" onClick={closeDrawer}>
                    <Link
                      to="/LabourAgreements"
                      className={
                        activeLink === "/LabourAgreements" ? "active" : ""
                      }
                    >
                      {" "}
                      Labour Agreements
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="/SkillsAssessment" onClick={closeDrawer}>
                    <Link
                      to="/SkillsAssessment"
                      className={
                        activeLink === "/SkillsAssessment" ? "active" : ""
                      }
                    >
                      {" "}
                      Skills Assessment
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="/DAMA" onClick={closeDrawer}>
                    <Link
                      to="/DAMA"
                      className={activeLink === "/DAMA" ? "active" : ""}
                    >
                      {" "}
                      DAMA
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="/ArtVisaAppeals" onClick={closeDrawer}>
                    <Link
                      to="/ArtVisaAppeals"
                      className={
                        activeLink === "/ArtVisaAppeals" ? "active" : ""
                      }
                    >
                      {" "}
                      ART Visa Appeals
                    </Link>
                  </Menu.Item>
                </SubMenu>

                <SubMenu key="CorporateServ" title="Corporate Services">
                  <Menu.Item key="/Introduction" onClick={closeDrawer}>
                    <Link
                      to="/Introduction"
                      className={activeLink === "/Introduction" ? "active" : ""}
                    >
                      {" "}
                      Introduction
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="/SponsorVisaApp" onClick={closeDrawer}>
                    <Link
                      to="/SponsorVisaApp"
                      className={
                        activeLink === "/SponsorVisaApp" ? "active" : ""
                      }
                    >
                      {" "}
                      Sponsor Visa Application Services
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="/SkillInDemand" onClick={closeDrawer}>
                    <Link
                      to="/SkillInDemand"
                      className={
                        activeLink === "/SkillInDemand" ? "active" : ""
                      }
                    >
                      {" "}
                      Skills in Demand Visa
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="/EmployerNomVisa" onClick={closeDrawer}>
                    <Link
                      to="/EmployerNomVisa"
                      className={
                        activeLink === "/EmployerNomVisa" ? "active" : ""
                      }
                    >
                      {" "}
                      Employer Nomination Scheme Visa
                    </Link>
                  </Menu.Item>
                  <Menu.Item
                    key="/SkilledEmpSponRegionVisa "
                    onClick={closeDrawer}
                  >
                    <Link
                      to="/SkilledEmpSponRegionVisa "
                      className={
                        activeLink === "/SkilledEmpSponRegionVisa "
                          ? "active"
                          : ""
                      }
                    >
                      {" "}
                      Skilled Employer Sponsored Regional Visa
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="/SponsorOblig" onClick={closeDrawer}>
                    <Link
                      to="/SponsorOblig"
                      className={activeLink === "/SponsorOblig" ? "active" : ""}
                    >
                      {" "}
                      Sponsorship Obligations
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="/AppealingSponsoeVisa" onClick={closeDrawer}>
                    <Link
                      to="/AppealingSponsoeVisa"
                      className={
                        activeLink === "/AppealingSponsoeVisa" ? "active" : ""
                      }
                    >
                      {" "}
                      Appealing an Employer - Sponsored Visa
                    </Link>
                  </Menu.Item>
                </SubMenu>

                <SubMenu key="sub0" title="Coaching">
                  <Menu.Item key="/PTE" onClick={closeDrawer}>
                    <Link
                      to="/PTE"
                      className={activeLink === "/PTE" ? "active" : ""}
                    >
                      {" "}
                      PTE
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="/IELTS" onClick={closeDrawer}>
                    <Link
                      to="/IELTS"
                      className={activeLink === "/IELTS" ? "active" : ""}
                    >
                      {" "}
                      IELTS
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="/NAATI_CCL" onClick={closeDrawer}>
                    <Link
                      to="/NAATI"
                      className={activeLink === "/NAATI_CCL" ? "active" : ""}
                    >
                      {" "}
                      NAATI CCL
                    </Link>
                  </Menu.Item>
                </SubMenu>

                <SubMenu key="resources" title="Resources">
                  <Menu.Item key="/Blog" onClick={closeDrawer}>
                    <Link
                      to="/Blog"
                      className={activeLink === "/Blog" ? "active" : ""}
                    >
                      {" "}
                      Blog
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="/ReferFriend" onClick={closeDrawer}>
                    <Link
                      to="/ReferFriend"
                      className={activeLink === "/ReferFriend" ? "active" : ""}
                    >
                      {" "}
                      Refer a Friend
                    </Link>
                  </Menu.Item>
                </SubMenu>

                <Menu.Item key="/ContactUs" onClick={closeDrawer}>
                  <Link
                    to="/ContactUs"
                    className={activeLink === "/ContactUs" ? "active" : ""}
                  >
                    {" "}
                    Contact
                  </Link>
                </Menu.Item>
              </Menu>
            </Drawer>
          </div>
        </div>
      </div>
    </>
  );
};
export default Navigation;
